import { render, staticRenderFns } from "./settingAccountTaxes.vue?vue&type=template&id=3e427b28&scoped=true&"
import script from "./settingAccountTaxes.vue?vue&type=script&lang=js&"
export * from "./settingAccountTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e427b28",
  null
  
)

export default component.exports